import { yupResolver } from "@hookform/resolvers/yup";
import { useCallback, type FC } from "react";
import { useForm } from "react-hook-form";

import { useRootDispatch } from "@ds/hooks";

import { createCampaignModel } from "@ds/modules/content/campaigns/utils/model";

import { DescriptionControl } from "@ds/components/forms/control/description-control";
import { WizardPage, type WizardChildStepProps } from "@ds/components/wizard";

import { campaignsActions } from "../../../redux/slice";
import { createValidationSchema } from "../../../utils/validation-schema";
import { CampaignMixingStrategyControl } from "../controls/campaign-mixing-strategy-control";
import { CampaignNameControl } from "../controls/campaign-name-control";

export const Step1Main: FC<WizardChildStepProps> = ({ nextStep, ...rest }) => {
  const { control, getValues, handleSubmit } = useForm<Campaign>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: createCampaignModel(),
    resolver: yupResolver(createValidationSchema.step1),
  });

  const dispatch = useRootDispatch();
  const onNextClickHandler = useCallback(() => {
    dispatch(campaignsActions.createCampaign(getValues()));
    if (nextStep) {
      nextStep();
    }
  }, [dispatch, getValues, nextStep]);

  return (
    <WizardPage {...rest} title="Add campaign" nextStep={handleSubmit(onNextClickHandler)}>
      <CampaignNameControl control={control} autoFocus />
      <DescriptionControl control={control} />
      <CampaignMixingStrategyControl control={control} />
    </WizardPage>
  );
};
